import { useCallback, useRef, useState } from 'react'

export function useHorizontalScroll() {
  const scrollRef = useRef<HTMLDivElement | null>(null)

  const [isDragging, setIsDragging] = useState(false)
  const [isMouseDown, setIsMouseDown] = useState(false)
  const [startX, setStartX] = useState(0)
  const [scrollLeft, setScrollLeft] = useState(0)

  const handleMouseDown = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    if (!scrollRef.current) {
      return
    }

    setIsMouseDown(true)
    setStartX(e.pageX - scrollRef.current.offsetLeft)
    setScrollLeft(scrollRef.current.scrollLeft)
  }, [])

  const handleMouseLeave = useCallback(() => {
    setIsMouseDown(false)
  }, [])

  const handleMouseUp = useCallback(() => {
    setIsMouseDown(false)
  }, [])

  const handleMouseMove = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    if (!isMouseDown || !scrollRef.current) {
      return
    }

    e.preventDefault()

    const x = e.pageX - scrollRef.current.offsetLeft

    if (x !== startX) {
      setIsDragging(true)
    }

    const walk = (x - startX) * 2
    scrollRef.current.scrollLeft = scrollLeft - walk
  }, [isMouseDown, startX, scrollLeft])

  const handleClick = useCallback(() => {
    setIsDragging(false)
  }, [])

  return {
    scrollRef,
    isMouseDown,
    isDragging,
    startX,
    scrollLeft,
    handleMouseDown,
    handleMouseLeave,
    handleMouseUp,
    handleMouseMove,
    handleClick,
  }
}
